// Auto generated file, do not manually modify!
// com.hotpads.rentalgrowth.web.listing.handler.RentalGrowthUserPropertyListingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetListingByAddressResponseWebDto } from '../..';

interface GetByAddressParams {
  fullAddress: string;
  unit?: string;
}

export const RentalGrowthUserPropertyListingWebApiHandler_getByAddress_Path = '/api/web/v1/users/listings/getByAddress';

/**
 * Get most relevant listing for a user for a given address
 */
export const RentalGrowthUserPropertyListingWebApiHandler_getByAddress = (
  getParams: GetByAddressParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetByAddressParams, never, GetListingByAddressResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalGrowthUserPropertyListingWebApiHandler_getByAddress_Path,
      method: 'GET',
      contextPath: '/rental-growth-api',
    },
    client,
  );
};
